export type RateSource = 'Org Default' | 'Project Override' | 'Person Override' | 'Client Agreed';
export type RateType = 'Cost' | 'Bill';

export interface RateCardEntry {
  id: string;
  projectId: string;
  roleId: string;
  roleName: string;
  personId?: string;
  personName?: string;
  hourlyAmount: number;
  dailyAmount: number;
  rateType: RateType;
  effectiveFrom: string; // ISO date
  effectiveTo?: string; // ISO date
  source: RateSource;
  createdBy: string;
  createdDate: string; // ISO date
  notes?: string;
}

export interface RateCardSummary {
  averageHourlyBillRate: number;
  averageHourlyCostRate: number;
  averageDailyBillRate: number;
  averageDailyCostRate: number;
  averageMargin: number;
  roleCount: number;
  lastUpdated: string;
  lastUpdatedBy: string;
}

export interface RoleRate {
  roleId: string;
  roleName: string;
  hourlyCostRate: number;
  hourlyBillRate: number;
  dailyCostRate: number;
  dailyBillRate: number;
  margin: number;
  effectiveFrom: string;
  source: RateSource;
  assignedPeople: AssignedPerson[];
}

export interface AssignedPerson {
  personId: string;
  personName: string;
  hourlyCostRate: number;
  hourlyBillRate: number;
  dailyCostRate: number;
  dailyBillRate: number;
  margin: number;
  effectiveFrom: string;
  source: RateSource;
}

export interface PersonRateOverride {
  personId: string;
  personName: string;
  hourlyCostRate: number;
  hourlyBillRate: number;
  dailyCostRate: number;
  dailyBillRate: number;
  effectiveFrom: string;
  notes?: string;
}

export interface BudgetImpact {
  revenueImpact: number;
  costImpact: number;
  marginImpact: number;
  affectedMonths: string[];
  remainingHours: number;
}

export interface UpdateRoleRateRequest {
  roleId: string;
  hourlyCostRate: number;
  hourlyBillRate: number;
  dailyCostRate: number;
  dailyBillRate: number;
  effectiveFrom: string;
  notes?: string;
}

export interface UpdatePersonRateRequest {
  roleId: string;
  personId: string;
  hourlyCostRate: number;
  hourlyBillRate: number;
  dailyCostRate: number;
  dailyBillRate: number;
  effectiveFrom: string;
  notes?: string;
}

// Helper functions
export const calculateMargin = (billRate: number, costRate: number): number => {
  if (billRate === 0) return 0;
  return Math.round(((billRate - costRate) / billRate) * 100);
};

export const calculateMarkup = (billRate: number, costRate: number): number => {
  if (costRate === 0) return 0;
  return Math.round(((billRate - costRate) / costRate) * 100);
};
